import { FC } from 'react';
import { Control, UseFormGetValues } from 'react-hook-form';
import Divider from '@mui/material/Divider';
import { BulletinUpdateFormValues } from '../schema';
import GeneralInformation from './GeneralInformation';
import UpdateContent from './UpdateContent';
import RecipientList from './RecipientList';

type Props = {
  control: Control<BulletinUpdateFormValues>;
  getValues: UseFormGetValues<BulletinUpdateFormValues>;
  readOnly: boolean;
  hasUkInvestorWithCommitment: boolean;
};

const AddEditBulletinUpdateForm: FC<Props> = ({
  control,
  getValues,
  readOnly,
  hasUkInvestorWithCommitment,
}) => {
  return (
    <>
      <GeneralInformation
        control={control}
        getValues={getValues}
        readOnly={readOnly}
      />
      {readOnly ? <Divider /> : null}
      <UpdateContent
        control={control}
        getValues={getValues}
        readOnly={readOnly}
        hasUkInvestorWithCommitment={hasUkInvestorWithCommitment}
      />
      {readOnly ? (
        <>
          <Divider />
          <RecipientList />
        </>
      ) : null}
    </>
  );
};

export default AddEditBulletinUpdateForm;
